import React from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import {
    CSSTransition,
    TransitionGroup
} from 'react-transition-group';
import { Alert } from "@mui/material";

import { HomePage, FormPage, LoginPage, FormOptionPage, ActivatePage, SavedFormPage, SubmittedFormHistoryPage } from "../pages";
import DetectNetwork from "../utilities/DetectNetwork";
import "../App.css";
import { useTranslation } from 'react-i18next';

const Navigation = () => {
    const { online } = DetectNetwork();
    const location = useLocation();
    const { t: translate } = useTranslation();

    return (
        <>
            <TransitionGroup component={null}>
                <CSSTransition
                    key={location.key}
                    classNames="page"
                    timeout={{
                        enter: 300,
                        exit: 300,
                    }}
                >
                    <Routes location={location}>
                        <Route path="/" element={<HomePage />} />
                        <Route path="/form" element={<FormOptionPage />} />
                        <Route path="/operation" element={<FormPage />} />
                        <Route path="/login" element={<LoginPage />} />
                        <Route path="/activate" element={<ActivatePage />} />
                        <Route path="/savedForm" element={<SavedFormPage />} />
                        <Route path="/history" element={<SubmittedFormHistoryPage />} />
                    </Routes>
                </CSSTransition>
            </TransitionGroup>
            {
                !online &&
                <div className="offline-alert">
                    <Alert severity="error" style={{ width: '100%' }}>{translate('noConnection')}</Alert>
                </div>
            }
        </>
    )
}

export default Navigation;